module.exports = __webpack_public_path__ + "img/noimage.114326a5.png";